angular.module("myApp").service("StateSaver", [
  "$rootScope",
  "$cacheFactory",
  ($rootScope, $cacheFactory) => {
    const $cache = $cacheFactory("state-saver")
    $rootScope.$on("logoutDone", () => $cache.removeAll())
    return $cache
  },
])
